import axiosClient from "@/libs/axiosClient";

export const _checkCname = (data) => {
    return axiosClient.post(`/validate/checkcname`, data);
};

export const _certRequirements = ({ groupName = "", servername = "" }) => {
    return axiosClient.get(`/validate/certRequirements?groupName=${groupName}&servername=${servername}`);
};



// WEBPACK FOOTER //
// ./src/api/validate.js